/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolVideocamIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-videocam"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M3.55 20.75Q2.45 20.75 1.68 19.98Q0.9 19.2 0.9 18.1L0.9 5.9Q0.9 4.8 1.68 4.03Q2.45 3.25 3.55 3.25L15.75 3.25Q16.85 3.25 17.63 4.03Q18.4 4.8 18.4 5.9L18.4 10.05L21.98 6.47Q22.3 6.15 22.7 6.33Q23.1 6.5 23.1 6.95L23.1 17.05Q23.1 17.5 22.7 17.68Q22.3 17.85 21.98 17.52L18.4 13.95L18.4 18.1Q18.4 19.2 17.63 19.98Q16.85 20.75 15.75 20.75Z" fill={color} />
    </svg>
  );
}
